import React, { useState } from 'react'
import Form from 'react-bootstrap/Form'
import Table from 'react-bootstrap/Table';
import Button from 'react-bootstrap/Button';

/* eslint-disable react/prop-types */
const ChangeSchedulesForm = ({ schedules, onSchedulesChange }) => {
    const days = ['Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi', 'Dimanche']
    const morningScheduleOptions = [
        '07:00', '07:30', '08:00', '08:30', '09:00', '09:30', '10:00', '10:30', '11:00', '11:30', '12:00', '12:30', '13:00', '13:30', '14:00'
    ];
    const afternoonScheduleOptions = [
        '12:00', '12:30', '13:00', '13:30', '14:00', '14:30', '15:00', '15:30', '16:00', '16:30', '17:00', '17:30', '18:00', '18:30', '19:00', '19:30', '20:00', '20:30', '21:00', '21:30', '22:00', '22:30'
    ];
    const [newSchedules, setNewSchedules] = useState([...schedules]);

    function changeSchedule(event, day, key) {
        const newValue = event.target.value;
        const schedulesUpdated = newSchedules.map((schedule) => {
            if (schedule.jourouvertureDate === day) {
                schedule[key] = newValue;
            }
            return schedule;
        })
        setNewSchedules([...schedulesUpdated]);
    }

    function changeOpening(event, day, moment) {
        const newValue = event.target.checked;
        const schedulesUpdated = newSchedules.map((schedule) => {
            if (schedule.jourouvertureDate === day) {
                // Ouverture d'un créneau
                if (newValue === false) {
                    if (moment === 'morning') {
                        schedule.matinHeureouverture = '07:00';
                        schedule.matinHeurefermeture = '12:00';
                    }
                    if (moment === 'afternoon') {
                        schedule.amHeureouverture = '12:00';
                        schedule.amHeurefermeture = '18:00';
                    }
                }
                // Fermeture d'un créneau
                if (newValue === true) {
                    if (moment === 'morning') {
                        delete schedule.matinHeureouverture;
                        delete schedule.matinHeurefermeture;
                    }
                    if (moment === 'afternoon') {
                        delete schedule.amHeureouverture;
                        delete schedule.amHeurefermeture;
                    }
                }
            }
            return schedule;
        })
        setNewSchedules([...schedulesUpdated]);
    }

    function getDefaultSchedule(day, moment) {
        const found = schedules.find(schedule => schedule.jourouvertureDate === day);

        return found === null || found.length === 0 ? '' : found[moment];
    }

    function floristIsClosedForTheMorning(day) {
        const found = schedules.find(schedule => schedule.jourouvertureDate === day);

        return found.magasinFerme || !found.matinHeurefermeture || !found.matinHeureouverture;
    }

    function floristIsClosedForTheAfternoon(day) {
        const found = schedules.find(schedule => schedule.jourouvertureDate === day);

        return found.magasinFerme || !found.amHeurefermeture || !found.amHeureouverture;
    }

    function hasScheduleError(day, moment) {
        const found = newSchedules.find(schedule => schedule.jourouvertureDate === day);
        if (moment === 'morning' && found.matinHeureouverture && found.matinHeurefermeture) {
            const indexMorning1 = morningScheduleOptions.indexOf(found.matinHeureouverture);
            const indexMorning2 = morningScheduleOptions.indexOf(found.matinHeurefermeture);
            return indexMorning1 >= indexMorning2;
        }
        if (moment === 'afternoon' && found.amHeureouverture && found.amHeurefermeture) {
            const indexMorning1 = afternoonScheduleOptions.indexOf(found.amHeureouverture);
            const indexMorning2 = afternoonScheduleOptions.indexOf(found.amHeurefermeture);
            return indexMorning1 >= indexMorning2;
        }

        return false;
    }

    return (
        <form onSubmit={(event) => onSchedulesChange(event, newSchedules)}>
            <Table striped bordered hover>
                <thead>
                    <tr>
                        <th></th>
                        <th>Fermetures</th>
                        <th colSpan={2}>Matin</th>
                        <th colSpan={2}>Après midi</th>
                    </tr>
                </thead>
                <tbody>
                    {days.map((day, key) => (
                        <tr key={key}>
                            <td>{day}</td>
                            <td>
                                <Form.Check
                                    type='checkbox'
                                    reverse
                                    inline
                                    id='morning'
                                    label='Matin'
                                    checked={floristIsClosedForTheMorning(day)}
                                    onChange={(event) => changeOpening(event, day, 'morning')}
                                    style={{'marginRight': '16px'}}
                                />
                                <Form.Check
                                    type='checkbox'
                                    reverse
                                    inline
                                    id='afternoon'
                                    label="Après midi"
                                    checked={floristIsClosedForTheAfternoon(day)}
                                    onChange={(event) => changeOpening(event, day, 'afternoon')}
                                />
                            </td>
                            {floristIsClosedForTheMorning(day) ?
                                <td colSpan={2}>
                                    Fermé
                                </td>
                            :
                                <>
                                    <td style={{'backgroundColor': hasScheduleError(day, 'morning') ? 'red' : ''}}>
                                        <Form.Select
                                            aria-label={`Horaire du ${day} matin début`}
                                            value={getDefaultSchedule(day, 'matinHeureouverture')}
                                            onChange={(event) => changeSchedule(event, day, 'matinHeureouverture')}
                                        >
                                            {morningScheduleOptions.map((schedule, key) => (
                                                <option key={key} value={schedule}>{schedule}</option>
                                            ))}
                                        </Form.Select>
                                    </td>
                                    <td style={{'backgroundColor': hasScheduleError(day, 'morning') ? 'red' : ''}}>
                                        <Form.Select
                                            aria-label={`Horaire du ${day} matin fin`}
                                            value={getDefaultSchedule(day, 'matinHeurefermeture')}
                                            onChange={(event) => changeSchedule(event, day, 'matinHeurefermeture')}
                                        >
                                            {morningScheduleOptions.map((schedule, key) => (
                                                <option key={key} value={schedule}>{schedule}</option>
                                            ))}
                                        </Form.Select>
                                    </td>
                                </>
                            }
                            {floristIsClosedForTheAfternoon(day) ?
                                <td colSpan={2}>
                                    Fermé
                                </td>
                                :
                                <>
                                    <td style={{'backgroundColor': hasScheduleError(day, 'afternoon') ? 'red' : ''}}>
                                        <Form.Select
                                            aria-label={`Horaire du ${day} soir début`}
                                            value={getDefaultSchedule(day, 'amHeureouverture')}
                                            onChange={(event) => changeSchedule(event, day, 'amHeureouverture')}
                                        >
                                            {afternoonScheduleOptions.map((schedule, key) => (
                                                <option key={key} value={schedule}>{schedule}</option>
                                            ))}
                                        </Form.Select>
                                    </td>
                                    <td style={{'backgroundColor': hasScheduleError(day, 'afternoon') ? 'red' : ''}}>
                                        <Form.Select
                                            aria-label={`Horaire du ${day} soir fin`}
                                            value={getDefaultSchedule(day, 'amHeurefermeture')}
                                            onChange={(event) => changeSchedule(event, day, 'amHeurefermeture')}
                                        >
                                            {afternoonScheduleOptions.map((schedule, key) => (
                                                <option key={key} value={schedule}>{schedule}</option>
                                            ))}
                                        </Form.Select>
                                    </td>
                                </>
                            }
                        </tr>
                    ))}
                </tbody>
            </Table>
            <Button type='submit'>
                Valider mes horaires
            </Button>
        </form>
    )
}

export default ChangeSchedulesForm
